import React from 'react'
import Header from './../components/Header'
import { NavLink } from 'react-router-dom'

const Register = () => (<div>
  <section className="hero is-blue-gem-2">
    <Header/>
    <div className="hero-body">
      <div className="container has-text-centered">
        <h1 className="title">
          Register
        </h1>
        <h2 className="subtitle">
          Find parking spots nearby without the hussle!
        </h2>
      </div>
    </div>
  </section>
  <section className="section">
    <div className="container">
      <div className="columns is-centered">
        <div className="column is-half">
          <div className="box">
            <div className="field">
              <p className="subtitle is-4 has-text-centered">
                Sign up
              </p>
              <p className="control has-icons-left has-icons-right">
                <input className="input" type="email" placeholder="Email"/>
                <span className="icon is-small is-left">
                  <i className="fas fa-envelope"></i>
                </span>
                <span className="icon is-small is-right">
                  <i className="fas fa-check"></i>
                </span>
              </p>
            </div>
            <div className="field">
              <p className="control has-icons-left">
                <input className="input" type="password" placeholder="Password"/>
                <span className="icon is-small is-left">
                  <i className="fas fa-lock"></i>
                </span>
              </p>
            </div>
            <div className="field">
              <p className="control has-icons-left">
                <input className="input" type="password" placeholder="Confirm Password"/>
                <span className="icon is-small is-left">
                  <i className="fas fa-lock"></i>
                </span>
              </p>
            </div>
            <div className="field">
              <div className="control">
                <label className="checkbox">
                  <input type="checkbox"/> I agree to the <NavLink to="/terms">Terms and Privacy Policy</NavLink>
                </label>
              </div>
            </div>
            <div className="field">
              <p className="control">
                <button className="button button is-blue-gem-2 is-fullwidth is-medium">
                  Create account
                </button>
              </p>
            </div>
          </div>
          <p className="has-text-centered">
            Have an account? <NavLink to="/login">Sign in</NavLink>
          </p>
        </div>
      </div>
    </div>
  </section>
</div>)

export default Register



// WEBPACK FOOTER //
// ./src/containers/Register.js